import React from "react";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";
import { TextMediumSM } from "../../../../Components/Text/MediumText";
import ChecklistStatusManager from "./components/ChecklistStatusManager";

const MainPoChecklistSettings = () => {
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
              link: "/settings",
            },
            {
              name: "Procurement",
              link: "/settings/procurement",
            },
            {
              name: "PO Checklist",
            },
          ]}
        />
        <BackButton />
      </div>

      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll p-3">
        <TextMediumSM content="PO Checklists" />
        <div className="w-full flex flex-wrap justify-center md:justify-start items-start overflow-y-scroll">
          <div className="w-full md:w-1/2 lg:w-1/3 mt-4">
            <ChecklistStatusManager
              status="review"
              viewPropertyName="Review Checklist"
            />
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 mt-4">
            <ChecklistStatusManager
              status="verify"
              viewPropertyName="Verify Checklist"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPoChecklistSettings;
